import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const TiffinFood = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const permissions = useSelector(selectPermissions);
    const hasModulePermission = (moduleName) => {
        const modulePermission = permissions.find(
            permission => permission.ModuleName === moduleName
        );

        if (!modulePermission) return false;

        return (
            modulePermission.AddRec === "1" ||
            modulePermission.EditRec === "1" ||
            modulePermission.DeleteRec === "1" ||
            modulePermission.ViewRec === "1"
        );
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        {hasModulePermission("Food Class Master") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                link={{ pathname: '/foodclstable' }}
                                permissions={permissions}
                                title="Food Class Master"
                            />
                        )}
                        {hasModulePermission("Food Group Master") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                link={{ pathname: '/foodgrptable' }}
                                permissions={permissions}
                                title="Food Group Master"
                            />
                        )}

                        {hasModulePermission("Food SubGroup Master") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                permissions={permissions}
                                link={{ pathname: '/foodsubtable' }}
                                title="Food SubGroup Master"
                            />
                        )}

                        {hasModulePermission("Floor Master") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                link={{ pathname: '/foodtable' }}
                                permissions={permissions}
                                title="Food Master"
                            />
                        )}

                        {hasModulePermission("Recipe Category") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                link={{ pathname: '/recipe-cattable' }}
                                permissions={permissions}
                                title="Recipe Category"
                            />
                        )}

                        {hasModulePermission("Recipe Group") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                link={{ pathname: '/recipe-table' }}
                                permissions={permissions}
                                title="Recipe Group"
                            />
                        )}

                        {hasModulePermission("Recipe SubGroup") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                link={{ pathname: '/recipesub-table' }}
                                permissions={permissions}
                                title="Recipe SubGroup"
                            />
                        )}

                        {hasModulePermission("Recipe Ingredients Master") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                link={{ pathname: '/recipeitem-table' }}
                                permissions={permissions}
                                title="Recipe Ingredients Master"
                            />
                        )}

                        {/* {hasModulePermission("Recipe Ingredients") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                link={{ pathname: '/recipe-bomtable' }}
                                permissions={permissions}
                                title="Recipe Ingredients"
                            />
                        )} */}

                        {hasModulePermission("Meal Timing") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                link={{ pathname: '/mealtable' }}
                                permissions={permissions}
                                title="Meal Timing"
                            />
                        )}

                        {hasModulePermission("Vehicle Type") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                link={{ pathname: '/vehicle-type-table' }}
                                permissions={permissions}
                                title="Vehicle Type"
                            />
                        )}

                        {hasModulePermission("Vehicle Master") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                link={{ pathname: '/vehicle-table' }}
                                permissions={permissions}
                                title="Vehicle Master"
                            />
                        )}

                        {hasModulePermission("Driver Master") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                link={{ pathname: '/driver-master-table' }}
                                permissions={permissions}
                                title="Driver Master"
                            />
                        )}
                        {hasModulePermission("Food Menu") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={0}
                                link={{ pathname: '/food-menu-table' }}
                                permissions={permissions}
                                title="Food Menu"
                            />
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}

export default TiffinFood;